import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getConsultVideoRoom(consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_GET_VIDEO_ROOM_REQUESTED,
      ACTION_TYPES.CONSULT_GET_VIDEO_ROOM_SUCCEED,
      ACTION_TYPES.CONSULT_GET_VIDEO_ROOM_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/video-rooms`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function endConsultVideoRoom(roomId, body) {
  return {
    types: [
      ACTION_TYPES.CONSULT_END_VIDEO_ROOM_REQUESTED,
      ACTION_TYPES.CONSULT_END_VIDEO_ROOM_SUCCEED,
      ACTION_TYPES.CONSULT_END_VIDEO_ROOM_FAILED,
    ],
    promise: client => client.patch(`/video-rooms/${roomId}`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function closeAllConsultVideoRoom(consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_CLOSE_ALL_VIDEO_ROOM_REQUESTED,
      ACTION_TYPES.CONSULT_CLOSE_ALL_VIDEO_ROOM_SUCCEED,
      ACTION_TYPES.CONSULT_CLOSE_ALL_VIDEO_ROOM_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/video-rooms/close`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getOngoingCall(consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_GET_ONGOING_CALL_REQUESTED,
      ACTION_TYPES.CONSULT_GET_ONGOING_CALL_SUCCEED,
      ACTION_TYPES.CONSULT_GET_ONGOING_CALL_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}/video-rooms/ongoing`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getVirtualBackgrounds() {
  return {
    types: [
      ACTION_TYPES.ZOOM_VIRTUAL_BACKGROUND_LIST_REQUESTED,
      ACTION_TYPES.ZOOM_VIRTUAL_BACKGROUND_LIST_SUCCEED,
      ACTION_TYPES.ZOOM_VIRTUAL_BACKGROUND_LIST_FAILED,
    ],
    promise: client => client.get(`/zoom/backgrounds`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function logZoomEvent(body) {
  return {
    types: [
      ACTION_TYPES.ZOOM_EVENTS_REQUESTED,
      ACTION_TYPES.ZOOM_EVENTS_SUCCEED,
      ACTION_TYPES.ZOOM_EVENTS_FAILED,
    ],
    promise: client => client.post(`/video-rooms/events`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function videoTranscripts(roomId, body) {
  return {
    types: [
      ACTION_TYPES.ZOOM_VIDEO_TRANSCRIPT_REQUESTED,
      ACTION_TYPES.ZOOM_VIDEO_TRANSCRIPT_SUCCEED,
      ACTION_TYPES.ZOOM_VIDEO_TRANSCRIPT_FAILED,
    ],
    promise: client => client.post(`/video-rooms/${roomId}/transcriptions`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function openVideo(consultId, conversationId, patient) {
  return {
    type: ACTION_TYPES.VIDEO_TRIGGER_OPEN,
    payload: {
      consultId,
      conversationId,
      patient,
    },
  };
}

export function closeVideo() {
  return {
    type: ACTION_TYPES.VIDEO_TRIGGER_CLOSE,
  };
}
